import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import i18n from '../../../i18n';
import Utils from '../../../utils/utils';

const ConfirmModificationModal = ({
    displayGpPurchase,
    displayAutoRenewActivation,
    closeConfirmationModal,
    modifyExchange,
    gpAmount
}) => {
    const [loadingConfirm, setLoadingConfirm] = useState(false);

    const close = useCallback(() => {
        closeConfirmationModal();
    }, [closeConfirmationModal]);

    const confirm = useCallback(() => {
        setLoadingConfirm(true);
        modifyExchange(() => {
            setLoadingConfirm(false);
            closeConfirmationModal();
        });
    }, [modifyExchange, closeConfirmationModal]);

    return (
        <div className="modify-exchange-confirm">
            <img className="alert-icon" src={`${Utils.getAssetsDomain()}/images/website/myplan/alert.svg`} />
            <h1>{i18n.t('common:important')}</h1>
            {displayGpPurchase && displayAutoRenewActivation && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: i18n.t('exchange:requester_warning_AR_GP', {
                            amount: gpAmount
                        })
                    }}
                />
            )}
            {displayGpPurchase && !displayAutoRenewActivation && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: i18n.t('exchange:requester_warning_GP', {
                            amount: gpAmount
                        })
                    }}
                />
            )}
            {!displayGpPurchase && displayAutoRenewActivation && (
                <div dangerouslySetInnerHTML={{ __html: i18n.t('exchange:requester_warning_AR') }} />
            )}
            <div className="actions">
                <button
                    onClick={confirm}
                    id="accept"
                    className={classNames('button button--hover button--yellow btn-ajax send-request-btn', {
                        sending: loadingConfirm
                    })}
                >
                    {i18n.t('exchange:understood')}
                </button>
                <button
                    onClick={close}
                    id="cancel"
                    className="button button--hover btn-ajax send-request-btn"
                >
                    {i18n.t('common:cancel')}
                </button>
            </div>
        </div>
    );
};

ConfirmModificationModal.defaultProps = {
    gpAmount: null
};

ConfirmModificationModal.propTypes = {
    modifyExchange: PropTypes.func,
    displayGpPurchase: PropTypes.bool,
    displayAutoRenewActivation: PropTypes.bool,
    closeConfirmationModal: PropTypes.func.isRequired,
    gpAmount: PropTypes.number
};

export default ConfirmModificationModal;
